import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../modules/login/styles/LoginPage.css';

export const LandingPage: React.FC = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleContinue = async () => {
    const enteredPassword = password.trim();
    setError('');

    if (!enteredPassword) {
      sessionStorage.removeItem('mpm_gate_access');
      setError('Please enter the access password');
      return;
    }

    try {
      const response = await fetch('/api/verify-access', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: enteredPassword })
      });

      const data = await response.json();

      if (data?.success === true) {
        sessionStorage.setItem('mpm_gate_access', 'true');
        navigate('/login');
      } else {
        sessionStorage.removeItem('mpm_gate_access');
        setError('Invalid access password');
      }
    } catch (apiError) {
      console.error('Access verification failed:', apiError);
      sessionStorage.removeItem('mpm_gate_access');
      setError('Unable to verify access password. Please try again.');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f4f7fb, #e9eef6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Inter, sans-serif',
      }}
    >
      <div
        style={{
          width: '420px',
          background: '#ffffff',
          borderRadius: '14px',
          padding: '40px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
        }}
      >
        <h2
          style={{
            textAlign: 'center',
            color: '#002e6d',
            fontSize: '20px',
            fontWeight: 600,
            marginBottom: '6px',
          }}
        >
          Secure Access
        </h2>

        <p
          style={{
            textAlign: 'center',
            fontSize: '14px',
            color: '#6b7280',
            marginBottom: '24px',
          }}
        >
          Enter your access password to continue
        </p>

        <input
          type="password"
          placeholder="Access password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: '100%',
            height: '46px',
            padding: '0 12px',
            fontSize: '15px',
            borderRadius: '8px',
            border: '1px solid #d1d5db',
            outline: 'none',
          }}
        />

        {error && (
          <div style={{ marginTop: '12px', fontSize: '13px', color: '#dc2626' }}>
            ⚠️ {error}
          </div>
        )}

        <button
          onClick={handleContinue}
          style={{
            width: '100%',
            height: '46px',
            marginTop: '26px',
            background: '#002e6d',
            color: '#ffffff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};
